// src/pages/AdminSurgicalExcelUpload.js

import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import api from "../api/api";

function AdminSurgicalExcelUpload() {
  const [summaryInfo, setSummaryInfo] = useState(null);

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadInfo, setUploadInfo] = useState(null);
  const [cleanInfo, setCleanInfo] = useState(null);
  const navigate = useNavigate();


  const handleViewSummary = async () => {
  setMessage("");
  setUploadInfo(null);
  setCleanInfo(null);

  try {
    const res = await api.get("surgical/stock-summary/");
    setSummaryInfo(res.data);
    setMessage("Stock Summary Loaded ✅");
  } catch (error) {
    console.error(error);
    setMessage("Failed to load summary");
  }
};


  // BACK BUTTON (not logout)
  const handleBack = () => {
    navigate(-1);
  };

  // Helpers
  const formatMoney = (v) => {
    if (v === null || v === undefined) return "₹0.00";
    try {
      return v.toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
      });
    } catch {
      return `₹${v}`;
    }
  };
const safeFixed = (num) => (num ? Number(num).toFixed(2) : "0.00");

  const formatNumber = (v) => {
    if (v === null || v === undefined) return "0";
    try {
      return v.toLocaleString("en-IN");
    } catch {
      return String(v);
    }
  };

  // Handle file change
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected || null);
    setMessage("");
    setUploadInfo(null);
    setCleanInfo(null);
  };

  // Upload Surgical Excel
  const handleUpload = async () => {
    if (!file) return setMessage("Please select a file first.");

    setIsUploading(true);
    setMessage("Uploading...");
    setUploadInfo(null);
    setCleanInfo(null);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await api.post("surgical/upload-excel/", formData);
      setUploadInfo(res.data);
      setMessage("Upload successful ✅");
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.error ||
          error.response?.data?.detail ||
          "Upload failed (see console)"
      );
    } finally {
      setIsUploading(false);
    }
  };

  // Clean Duplicate Surgical Items
  const handleCleanDuplicates = async () => {
    setMessage("");
    setCleanInfo(null);

    try {
      const res = await api.post("surgical/clean-duplicates/");
      setCleanInfo(res.data);
      setMessage("Duplicate cleaning completed ✅");
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.error ||
          error.response?.data?.detail ||
          "Failed to clean duplicates"
      );
    }
  };

  // Download Surgical Stock Excel
  const handleDownloadStock = async () => {
    try {
      const res = await api.get("surgical/download-stock/", {
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });


      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "surgical_stock.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.error ||
          error.response?.data?.detail ||
          "Failed to download stock file"
      );
    }
  };

const handleResetSales = async () => {
  if (!window.confirm("Are you sure? This will reset ALL sales to 0!")) return;

  try {
    await api.post("/reset-sales/");
    alert("All sales reset to 0 ✔");
    
    // Reload summaries if needed
    //setSalesSummary(null);
    //setStockSummary(null);
  } catch (err) {
    console.error(err);
    alert("Failed to reset sales ❌");
  }
};

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.headerRow}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={styles.headerIcon}>🧴</span>
            <h2 style={styles.title}>Upload Surgical Excel</h2>
          </div>
        </div>

        {/* File Input */}
        <div style={{ marginBottom: 16 }}>
          <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
          {file && (
            <p style={styles.smallText}>
              Selected: <strong>{file.name}</strong>
            </p>
          )}
        </div>

        {/* Buttons */}

	<div style={styles.buttonRow}>
          <button
            onClick={handleUpload}
            disabled={!file || isUploading}
            style={{
              ...styles.buttonPrimary,
              opacity: !file || isUploading ? 0.6 : 1,
            }}
          >
            {isUploading ? "Uploading..." : "⬆ Upload Excel"}
          </button>
                  
          <button onClick={handleViewSummary} style={styles.buttonSecondary}>
            📊 View Summary
                     </button>

          <button onClick={handleCleanDuplicates} style={styles.buttonSecondary}>
            🧹 Clean Duplicate Items
          </button>

          <button onClick={handleDownloadStock} style={styles.buttonSecondary}>
            ⬇ Download Stock Excel
          </button>
                         <button
  className="btn btn-danger"
  onClick={handleResetSales}
>
  🔄 Reset All Sales
</button>

        </div>

        {/* Back Button Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <h2 style={styles.title}>📄 Upload Surgical Excel</h2>

          <button onClick={handleBack} style={styles.logoutButton}>
            BACK
          </button>
        </div>

        {/* Status Message */}
        {message && <p style={styles.message}>{message}</p>}

        {/* Upload Summary */}
        {uploadInfo && (
          <div style={styles.infoBox}>
            <h4>Upload Summary</h4>
            <p>
              <strong>Created:</strong> {formatNumber(uploadInfo.created)}
            </p>
            <p>
              <strong>Updated:</strong> {formatNumber(uploadInfo.updated)}
            </p>
            <p>
              <strong>Total Items:</strong> {formatNumber(uploadInfo.total_items)}
            </p>
            <p>
              <strong>Total Stock Units:</strong>{" "}
              {formatNumber(uploadInfo.total_stock_units)}
            </p>

            <hr style={styles.hr} />

            <p>
              <strong>Total Purchase Value:</strong>{" "}
              {formatMoney(uploadInfo.total_purchase_value)}
            </p>
            <p>
              <strong>Total Sale Value:</strong>{" "}
              {formatMoney(uploadInfo.total_sale_value)}
            </p>
            <p>
              <strong>Profit:</strong>{" "}
              {formatMoney(uploadInfo.total_profit_value || 0)
}{" "}
              {safeFixed(uploadInfo.total_profit_percent)}%

            </p>
          </div>
        )}
        {summaryInfo && (
  <div style={styles.infoBox}>
    <h4>Current Stock Summary</h4>

    <p><strong>Total Items:</strong> {formatNumber(summaryInfo.total_items)}</p>
    <p><strong>Total Stock Units:</strong> {formatNumber(summaryInfo.total_stock_units)}</p>

    <hr style={styles.hr} />

    <p><strong>Total Purchase Value:</strong> {formatMoney(summaryInfo.total_purchase_value)}</p>
    <p><strong>Total Sale Value:</strong> {formatMoney(summaryInfo.total_sale_value)}</p>
    <p>
      <strong>Total Profit:</strong> {formatMoney(summaryInfo.total_profit_value)}
      {" "}({safeFixed(summaryInfo.total_profit_percent)
}%)
    </p>

    <p>
      <strong>Total Sale Done Till Now:</strong>
      {" "} {formatMoney(summaryInfo.total_sale_done_till_now)}
    </p>
  </div>
)}


        {/* Duplicate Cleaning Summary */}
        {cleanInfo && (
          <div style={styles.infoBox}>
            <h4>Duplicate Cleaning Summary</h4>
            <p>
              <strong>Duplicate Name Groups:</strong>{" "}
              {formatNumber(cleanInfo.duplicate_name_groups)}
            </p>
            <p>
              <strong>Records Removed:</strong>{" "}
              {formatNumber(cleanInfo.records_removed)}
            </p>
          </div>
        )}

        {/* Company Stats */}
        {summaryInfo?.company_stats && (
  <div style={styles.statsSection}>
    <h4>Company-wise Inventory</h4>
    <div style={styles.tableWrapper}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Company</th>
            <th style={styles.th}>Items</th>
            <th style={styles.th}>Stock</th>
            <th style={styles.th}>Purchase Value</th>
            <th style={styles.th}>Sale Value</th>
            <th style={styles.th}>Profit</th>
          </tr>
        </thead>
        <tbody>
          {summaryInfo.company_stats.map((row) => (
            <tr key={row.company}>
              <td style={styles.td}>{row.company}</td>
              <td style={styles.td}>{formatNumber(row.items_count)}</td>
              <td style={styles.td}>{formatNumber(row.total_stock)}</td>
              <td style={styles.td}>{formatMoney(row.purchase_value)}</td>
              <td style={styles.td}>{formatMoney(row.sale_value)}</td>
              <td style={styles.td}>{formatMoney(row.profit_value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

        {uploadInfo?.company_stats?.length > 0 && (
          <div style={styles.statsSection}>
            <h4>Company-wise Inventory</h4>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Company</th>
                    <th style={styles.th}>Items</th>
                    <th style={styles.th}>Stock</th>
                    <th style={styles.th}>Purchase Value</th>
                    <th style={styles.th}>Sale Value</th>
                    <th style={styles.th}>Profit</th>
                  </tr>
                </thead>
                <tbody>
                  {uploadInfo.company_stats.map((row) => (
                    <tr key={row.company}>
                      <td style={styles.td}>{row.company}</td>
                      <td style={styles.td}>
                        {formatNumber(row.total_items)}
                      </td>
                      <td style={styles.td}>
                        {formatNumber(row.total_stock)}
                      </td>
                      <td style={styles.td}>{formatMoney(row.purchase_value)}</td>
                      <td style={styles.td}>{formatMoney(row.sale_value)}</td>
                      <td style={styles.td}>{formatMoney(row.profit_value)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Type Stats */}
        {uploadInfo?.type_stats?.length > 0 && (
          <div style={styles.statsSection}>
            <h4>Type-wise Inventory</h4>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Type</th>
                    <th style={styles.th}>Items</th>
                    <th style={styles.th}>Stock</th>
                    <th style={styles.th}>Purchase Value</th>
                    <th style={styles.th}>Sale Value</th>
                    <th style={styles.th}>Profit</th>
                  </tr>
                </thead>
                <tbody>
                  {uploadInfo.type_stats.map((row) => (
                    <tr key={row.type}>
                      <td style={styles.td}>{row.type}</td>
                      <td style={styles.td}>{formatNumber(row.total_items)}</td>
                      <td style={styles.td}>{formatNumber(row.total_stock)}</td>
                      <td style={styles.td}>{formatMoney(row.purchase_value)}</td>
                      <td style={styles.td}>{formatMoney(row.sale_value)}</td>
                      <td style={styles.td}>{formatMoney(row.profit_value)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* Styles */
const styles = {
  page: {
    display: "flex",
    justifyContent: "center",
    paddingTop: 40,
    paddingBottom: 40,
    background: "#f4f5fb",
    minHeight: "100vh",
  },
  card: {
    width: "90%",
    maxWidth: 1000,
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    padding: 24,
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  headerIcon: { fontSize: 28 },
  title: {
    fontSize: 22,
    fontWeight: "bold",
  },
  buttonRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 12,
  },
  buttonPrimary: {
    padding: "10px 18px",
    borderRadius: 8,
    border: "none",
    background: "#2a7ae4",
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: "bold",
  },
  buttonSecondary: {
    padding: "10px 18px",
    borderRadius: 8,
    border: "1px solid #999",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: "bold",
  },
  logoutButton: {
    padding: "8px 16px",
    background: "#000",
    color: "#fff",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: "bold",
  },
  message: { fontWeight: "bold", marginBottom: 12 },
  infoBox: {
    background: "#eef3ff",
    padding: 14,
    marginTop: 12,
    borderRadius: 10,
    border: "1px solid #cdd9ff",
  },
  hr: {
    borderTop: "1px solid #ccd5ff",
    margin: "10px 0",
  },
  statsSection: { marginTop: 18 },
  tableWrapper: {
    maxHeight: 320,
    overflow: "auto",
    border: "1px solid #eee",
    borderRadius: 8,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    background: "#f1f3f7",
    padding: 6,
    textAlign: "left",
    position: "sticky",
    top: 0,
    fontWeight: "600",
  },
  td: {
    padding: 6,
    borderBottom: "1px solid #f0f0f0",
  },
  smallText: { fontSize: 12, color: "#555" },
};

export default AdminSurgicalExcelUpload;
